module.exports = __webpack_public_path__ + "img/collection-weddingRingsBudgetMedium.4032671.webp";